module.exports = __webpack_public_path__ + "19b2c2304366bf6047f0eaf2976329f3.jpg";